import { Injectable, EventEmitter } from "@angular/core";
//import { Message } from '@angular/compiler/src/i18n/i18n_ast';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { AppInsightsService } from 'src/app/services/app-insights.service';
import { Observable, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import {AppService} from '../../services/app.service';

@Injectable({
    providedIn: 'root'
})

export class ESignatureService {
    Message: any;
    private baseURL = this.appService.config.apiBaseUrl;
    eSignatureMessagesListEmitter: EventEmitter<any> = new EventEmitter();
    eSignatureMessagesList = [];
    seletedStoreIdInCapturePage = 0;
    isDocumentLoadedByApi = false;
    nameFormat: any;
    pdfViewerUrl: string = '';


    constructor(private http: HttpClient,
                private appinsights: AppInsightsService,
                private appService: AppService) {

    }

    sendResponseMessageFromESignature(data): Observable<any> {
        const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
        let url = `${this.baseURL}/PushMessage/ResponseMessageFromESignature`;

        return this.http.post<any>(url, data, options)
            .pipe(
                map(res => {
                    return res;
                }),
                catchError(this.handleError)
            );
      }

      sendConnectionMessage(data): Observable<any> {
        const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
        let url = `${this.baseURL}/PushMessage/SendConnectionMessage`;

        return this.http.post<any>(url, data, options)
            .pipe(
                map(res => {
                    return res;
                }),
                catchError(this.handleError)
            );
      }


      private handleError(error: HttpErrorResponse) {
        console.error('server error:', error);
        if (error.error instanceof Error) {
          const errMessage = error.error.message;
          // this.appinsights.logEvent(errMessage);
          return throwError(errMessage);
        }
        return throwError(error || 'Node.js server error');
      }
}
